import { globalCommands, richTextEditorCommands } from 'app/app.commands';
import { conversationCommands } from 'app/views/layout/views/conversation/conversation.commands';
import { searchCommands } from 'app/views/layout/views/search/search.commands';
import { copilotDropdownCommands } from 'components/copilotDropdown';
/** Represents the available strongly typed commands. */
export const commandDefinitions = [
    ...conversationCommands,
    ...globalCommands,
    ...searchCommands,
    ...richTextEditorCommands,
    ...copilotDropdownCommands,
];
/** Represents the available commands. */
export const commands = commandDefinitions;
/** Represents the available internal commands. */
export const commandsInternal = commands.filter((command) => !command.isExternal);
/** Represents the available commands keybindings of which can be rebound. */
export const commandsKeyboardRebindable = commands.filter((command) => !(command.keyboard && !!command.keyboard.isNonRebindable));
